module.exports = __webpack_public_path__ + "img/26.b41b38b7.png";